import {UISprite} from "./UISprite";
import {Core} from "../../../Base/Core";

export class UIButton extends UISprite {
    constructor(...args) {
        super(...args);
        this.interactive = true;
        this.cursor = "pointer";
        this.on("pointertap", () => Core.Audio.Play("Click"));
        this._initTapHighlight();
    }
}
